// Function.ts
import { SetModalData, SetModalState } from "../interface/PopUp";

export function ReturnIndex(): void {    
    const rootElement = document.getElementById('root');
    if (rootElement) {
        rootElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

export function OpenFile(type: string, file: string): void {
    if(file !== ''){
        SetModalData('ShowFile', { "type": type, "file": file });
        SetModalState('ShowFile', true);
    }
}

export function AltStatus(origin: string, title: string, type: string, id: string | number, name: string, status: string | boolean): void {
    SetModalData('Confirmation', { "origin": origin, "title": title, "type": type, "id": id, "name": name, "status": status });
    SetModalState('Confirmation', true);
}

export function CallbackSuccess(title: string, text: string): void {
    SetModalData('ReturnResponse', { "page": "success", "title": title, "text": text });
    SetModalState('ReturnResponse', true);
}

export function CallbackError(title: string, text: string): void {
    SetModalData('ReturnResponse', { "page": "error", "title": title, "text": text });
    SetModalState('ReturnResponse', true);
}

export function CheckPassword(password: string, password2: string) {
    return {
        minLength: password.length >= 6,
        special:   /[^a-zA-Z0-9]/.test(password),
        hasNumber: /[0-9]/.test(password),
        hasUpper:  /[A-Z]/.test(password),
        match:     password !== '' && password === password2,
    };
}